const baseFontSize = 16;

export default {
  baseFontSize: 16,
  fontFamily: 'Avenir Next, Segoe UI, Helvetica, Roboto, sans-serif',
  borderRadius: `${baseFontSize / 4}px`,
};
